export const hodnotaNaCeste = (obj, cesta) => cesta.split('.').reduce((v, key) => v?.[key], obj);

export function pripravHromadnyFormular(karty, prazdny) {
  const rozdielne = [];
  const spolocne = (vzor, cesta) => Object.fromEntries(Object.entries(vzor).map(([key, value]) => {
    const path = cesta ? `${cesta}.${key}` : key;
    if (value && typeof value === 'object') return [key, spolocne(value, path)];
    const hodnoty = karty.map((karta) => hodnotaNaCeste(karta, path));
    if (hodnoty.every((v) => v === hodnoty[0])) return [key, hodnoty[0] ?? value];
    rozdielne.push(path);
    return [key, ''];
  }));
  const formular = { ...prazdny };
  for (const blok of ['zivotneMinima', 'spracovatelskyPoplatok', 'benefity']) {
    formular[blok] = spolocne(prazdny[blok], blok);
  }
  return { formular, rozdielne };
}
